module.exports = __webpack_public_path__ + "img/goldregen-2020-110.9a06c1e5.jpg";